import { createRoot } from 'react-dom/client';
import { BrowserRouter } from 'react-router-dom';
import { ApolloClient, ApolloProvider, createHttpLink, InMemoryCache } from '@apollo/client';
import { setContext } from '@apollo/client/link/context';
import { QueryClient, QueryClientProvider } from '@tanstack/react-query';
import { Provider } from 'react-redux';
import { store } from 'store';

import * as serviceWorker from 'serviceWorker';
import App from 'App';
import config from './config';
import 'assets/scss/style.scss';
import {LOCAL_STORAGE} from "./constants/constants";

const httpLink = createHttpLink({ uri: config.gqlApi });
const token = localStorage.getItem(LOCAL_STORAGE.JJ_INTERNAL);
const authLink = setContext((_, { headers }) => ({
    headers: {
        ...headers,
        authorization: token ? `Bearer ${token}` : '',
    },
}));

const client = new ApolloClient({
    cache: new InMemoryCache(),
    link: authLink.concat(httpLink),
});

const queryClient = new QueryClient();

const container = document.getElementById('root');
const root = createRoot(container);

root.render(
    <Provider store={store}>
        <ApolloProvider client={client}>
            <QueryClientProvider client={queryClient}>
                <BrowserRouter basename={config.basename}>
                    <App />
                </BrowserRouter>
            </QueryClientProvider>
        </ApolloProvider>
    </Provider>
);

serviceWorker.unregister();